import { useState } from 'react';

import { Panel, PanelContent, PanelTitle } from '@apigrowfinance/pbolt-panel';
import { FormattedMessage } from 'react-intl';

import LoadingError from '@components/loadingError/LoadingError';
import DividerPanel from '@components/overviewPanels/dividerPanel/DividerPanel';
import StatementsPanelItem, {
    AccountStatusPanelItemData,
} from '@components/overviewPanels/statementPanel/StatementsPanelItem';
import getEnumTranslation from '@utils/getEnumTranslation';

type AccountStatementsPanelProps = {
    onClick?: () => void;
    isLoading?: boolean;
    isError?: boolean;
    panels?: AccountStatusPanelItemData[];
};

const StatementsPanel = ({
    onClick,
    isLoading = false,
    isError = false,
    panels = [],
}: AccountStatementsPanelProps) => {
    const [isHovered, setIsHovered] = useState(false);

    if (isLoading && panels.length == 0) {
        // if loading and no data, then create some dummy data to be populated
        // for the skeleton
        const dummyData: AccountStatusPanelItemData = {
            statementId: '',
            date: '',
            isPaid: true,
            currencyCode: '',
            amountTotal: 0,
        };
        panels.push(dummyData);
        panels.push(dummyData);
        panels.push(dummyData);
    }

    if (isError) {
        return (
            <Panel>
                <PanelContent>
                    <LoadingError />
                </PanelContent>
            </Panel>
        );
    }

    return (
        <Panel isHovered={setIsHovered} onClick={onClick}>
            <PanelTitle
                hovered={isHovered}
                loading={isLoading}
                arrowLabel={getEnumTranslation('viewAll')}>
                <FormattedMessage
                    id="AccountStatementsPanel.latestStatement"
                    defaultMessage="Latest statements"
                />
            </PanelTitle>
            <PanelContent>
                <DividerPanel
                    isLoading={isLoading}
                    isHovered={isHovered}
                    isClickable={false}>
                    {panels.map((panel, i) => (
                        <StatementsPanelItem
                            key={`statement-${panel?.statementId || i}`}
                            itemData={panel}
                            isLoading={isLoading}
                        />
                    ))}
                </DividerPanel>
            </PanelContent>
        </Panel>
    );
};

export default StatementsPanel;
